export default "__VITE_ASSET__NkymuPEO__"